import { genericEscriptErrorMessage, invalidEscriptLengthErrorMessage, tokenLength } from '../constants/escript';
/**
 * escript token validation. Accepts full urls by stripping the expected token from the last segment
 * @param value - the user inputted token or url
 * @returns A mixed type to conform with RHF. True if an 18 char string, otherwise an error string
 */
export const validateEscriptToken = (value) => {
    if (value.length === tokenLength) {
        return true;
    }
    if (value.length > tokenLength) {
        const splitValueBySlash = value.split('/');
        return splitValueBySlash[splitValueBySlash.length - 1].length === tokenLength || genericEscriptErrorMessage;
    }
    return invalidEscriptLengthErrorMessage;
};
/**
 * escript token formatting. Trims input and splits token from url
 * @param value - the user inputted token or url
 * @returns whitespace trimmed, no slash string
 */
export const formatEscriptToken = (value) => {
    const trimmedToken = value.trim();
    const splitToken = trimmedToken.split('/');
    return splitToken[splitToken.length - 1];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjcmlwdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9lc2NyaXB0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSwwQkFBMEIsRUFBRSxnQ0FBZ0MsRUFBRSxXQUFXLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUVqSDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxLQUFhLEVBQUUsRUFBRTtJQUNwRCxJQUFJLEtBQUssQ0FBQyxNQUFNLEtBQUssV0FBVyxFQUFFLENBQUM7UUFDakMsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQsSUFBSSxLQUFLLENBQUMsTUFBTSxHQUFHLFdBQVcsRUFBRSxDQUFDO1FBQy9CLE1BQU0saUJBQWlCLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUMzQyxPQUFPLGlCQUFpQixDQUFDLGlCQUFpQixDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxNQUFNLEtBQUssV0FBVyxJQUFJLDBCQUEwQixDQUFDO0lBQzlHLENBQUM7SUFFRCxPQUFPLGdDQUFnQyxDQUFDO0FBQzFDLENBQUMsQ0FBQztBQUVGOzs7O0dBSUc7QUFDSCxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLEtBQWEsRUFBRSxFQUFFO0lBQ2xELE1BQU0sWUFBWSxHQUFHLEtBQUssQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNsQyxNQUFNLFVBQVUsR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQzNDLE9BQU8sVUFBVSxDQUFDLFVBQVUsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLENBQUM7QUFDM0MsQ0FBQyxDQUFDIn0=